import axios from 'axios';
import { getLanguageFromDomain } from './../i18n';

const bxUrl = axios.create({
    baseURL: process.env.VITE_HOST,
    withCredentials: true,
})

const apiUrl = axios.create({
    baseURL: process.env.VITE_HOST_API,
    withCredentials: true,
});

// Интерсептор для добавления заголовка Content-Language
apiUrl.interceptors.request.use(config => {
    const language = getLanguageFromDomain();
    config.headers['Content-Language'] = language;
    return config;
}, error => {
    return Promise.reject(error);
});

export { apiUrl, bxUrl, axios };

// todo add to interceptors json for post
// POST https://d2.testometrika.com/api/attempts/rating
//     Content-Type: application/json
// Accept: application/json